const Report = () =>
  import(
    /* webpackChunkName: "log-operation-editor" */ '@/pages/log/operation-editor/index.vue'
  )

const Detail = () =>
  import(
    /* webpackChunkName: "log-operation-editor" */ '@/pages/log/operation-editor/detail.vue'
  )

export default {
  path: 'operation-editor',
  meta: { label: 'operationEditor' },
  component: {
    name: 'OperationEditorLog',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'LogOperationEditorReport',
      path: '',
      meta: { label: 'report' },
      component: Report
    },
    {
      name: 'LogDetailOperationEditor',
      path: 'detail/:id',
      meta: { label: 'detail' },
      component: Detail,
      props: true
    }
  ]
}
